import { Icon } from '@iconify/react';
import { IconButton } from '@mui/material';
import React, { useState } from 'react';
import DialogUsuarioEditar from './DialogUsuarioEditar';

function EditMenu({ data }) {
  const [openEditarUser, setOpenEditarUser] = useState(false);
  return (
    <>
      <IconButton size="small" onClick={() => setOpenEditarUser(true)}>
        <Icon icon="eva:more-vertical-fill" />
      </IconButton>
      <DialogUsuarioEditar open={openEditarUser} onClose={setOpenEditarUser} data={data} />
    </>
  );
}

export default EditMenu;
